"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
exports.default = () => styles_1.createStyles({
    root: {
        margin: '2rem 2rem 0'
    }
});
//# sourceMappingURL=styles.js.map